import React, { useState, useEffect } from "react";
import FadeIn from "react-fade-in";
import { useLocation, useNavigate } from "react-router-dom";
import axios from "axios";
import { GET_RECIPE } from "../../../../Routes";
import { generateURLOptions } from "../../../../URLOptions";

import { FaChevronLeft } from "react-icons/fa6";

const SingleRecipe = () => {
  const navigate = useNavigate();
  const { state } = useLocation();

  const [isLoading, setIsLoading] = useState(true);
  const [visible, setVisible] = useState(true);

  const [recipeDetails, setRecipeDetails] = useState({});

  useEffect(() => {
    if (state?.recipeId) {
      getRecipeDetails();
    }
  }, [state]);

  const getRecipeDetails = async () => {
    await axios
      .get(GET_RECIPE + state?.recipeId, {
        headers: generateURLOptions(),
      })
      .then(async (response) => {
        console.log(response);
        if (response?.data?.success == false) {
          return alert(response?.data?.message ?? "");
        }
        setRecipeDetails(response.data?.data);
        setTimeout(() => {
          setIsLoading(false);
        }, 500);
      })
      .catch((error) => {
        console.log("Get Priority Notifications Error: ", error);
        return alert(error);
      });
  };

  const navigateBack = () => {
    setVisible(false);
    setTimeout(() => {
      navigate("/wellness/recipes");
    }, 350);
  };

  return !isLoading ? (
    <FadeIn delay={200} visible={visible}>
      <div className="container mx-auto flex flex-col justify-center items-center h-full w-full pb-24">
        <div className="mt-12 w-full">
          <h4 className="text-2xl font-semibold">
            {recipeDetails?.title ?? "Eat well 🍎"}
          </h4>

          <div
            onClick={navigateBack}
            className="flex flex-row justify-start items-center cursor-pointer mt-2"
          >
            <FaChevronLeft />
            <p className="text-black font-medium text-sm ml-2">Back</p>
          </div>
          <img
            src={recipeDetails?.image ?? ""}
            className="rounded-2xl w-full h-[50vh] object-cover mt-4"
            alt={recipeDetails?.title ?? ""}
          />

          <h4 className="text-black font-medium text-lg mt-8 mb-4">
            Ingredients
          </h4>
          {recipeDetails?.ingredients.map((ingredient) => {
            return (
              <div>
                <div className="flex flex-row justify-start items-center mb-2">
                  <div className="bg-blue-700 w-4 h-4 rounded-full mb-0" />
                  <p className="ml-3 text-black font-normal text-base">
                    {ingredient.ingredients}
                  </p>
                </div>
              </div>
            );
          })}

          <h4 className="text-black font-medium text-lg mt-8 mb-4">Method</h4>
          {recipeDetails?.description.map((method) => {
            return (
              <div>
                <p>
                  {method?.description?.split("\n").map((line, index) => (
                    <React.Fragment key={index}>
                      {line}
                      <br />
                    </React.Fragment>
                  ))}
                </p>
              </div>
            );
          })}

          <h4 className="text-black font-medium text-lg mt-8 mb-4">
            Nutritional Value
          </h4>
          <div
            className="align-items-center py-2"
            style={{ display: "flex", flex: 1, flexDirection: "row" }}
          >
            <p style={{ marginBottom: "0px" }}>
              {recipeDetails?.nutritional_value
                .split("\n")
                .map((line, index) => (
                  <React.Fragment key={index}>
                    {line}
                    <br />
                  </React.Fragment>
                ))}
            </p>
          </div>

          <h4 className="text-black font-medium text-lg mt-8 mb-4">
            Health Fact
          </h4>
          <p>
            {recipeDetails?.health_fact?.split("\n").map((line, index) => (
              <React.Fragment key={index}>
                {line}
                <br />
              </React.Fragment>
            ))}
          </p>
        </div>
      </div>
    </FadeIn>
  ) : (
    <>
      <FadeIn className="overflow-hidden">
        <div className="h-[90vh] relative flex flex-col justify-center items-center z-50">
          <div
            className="h-10 w-10 rounded-full border-4 border-mpPurple/30 border-t-mpPurple animate-spin"
            style={{ marginTop: 12, marginBottom: 12 }}
          />

          <h6 className="text-black font-medium">Updating Recipe Details</h6>
        </div>
      </FadeIn>
    </>
  );
};

export default SingleRecipe;
